'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.load = exports.login = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _reactLocalstorage = require('react-localstorage');

var _reactLocalstorage2 = _interopRequireDefault(_reactLocalstorage);

var _isomorphicFetch = require('isomorphic-fetch');

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _actionTypes = require('../actionTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  user: {
    outfeats: []
  },
  access_token: null
};

function reducer() {
  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
  var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  switch (action.type) {
    case _actionTypes.authActions.FETCH_USER.COMPLETED:
      return (0, _extends3.default)({}, state, {
        user: (0, _extends3.default)({}, state.user, action.result.data),
        access_token: action.result.access_token
      });
    case _actionTypes.outfeatActions.CREATE_OUTFEAT.COMPLETED:
      return (0, _extends3.default)({}, state, {
        user: (0, _extends3.default)({}, state.user, {
          outfeats: [].concat((0, _toConsumableArray3.default)(state.user.outfeats), [action.result.id])
        })
      });
    default:
      return state;
  }
}

var login = exports.login = function login() {
  return {
    types: _actionTypes.authActions.LOGIN.TYPES,
    promise: function promise(client) {
      return client.get('/login');
    }
  };
};

var load = exports.load = function load(access_token) {
  return {
    types: _actionTypes.authActions.FETCH_USER.TYPES,
    promise: function promise(client) {
      return client.get('/user?access_token=' + access_token);
    }
  };
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/auth.js
 ** module id = 284
 ** module chunks = 0
 **/